"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyleManager = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _StyleSet = require("./StyleSet");
var _paletteDefaultStyles = require("./palette-default-styles");
var _eventer = require("@blockwell/eventer");
let parsedDefaultStyles;
const systemFonts = ["times new roman", "helvetica", "tahoma", ""];
class StyleManager {
  static styleToCss(style, prefix, fonts) {
    let name;
    let state = "";
    if (style.type) {
      name = _StyleSet.BlockTypeStyle.className(style.type, style.layout);
    } else if (style.name) {
      name = style.name;
    } else {
      name = "palette-root-style";
    }
    if (!name) {
      console.warn("No name in style", style);
      return "";
    }
    if (style.state) {
      state = _StyleSet.ClassStyle.stateSelector(style.state);
    }
    return `${prefix ? prefix : ""} .${name}${state}{ ` + Object.entries(style.css).map(([prop, value]) => {
      if (fonts && prop === "font-family") {
        let family = getFontName(value);
        if (family) {
          fonts.add(family);
        }
      }
      return `${prop}:${value};`;
    }).join(" ") + "}";
  }
  static findSet(sets, {
    type,
    name,
    layout,
    state
  }) {
    if (type === "root") {
      return sets.find(it => it instanceof _StyleSet.RootStyle);
    } else if (type === "class") {
      return sets.find(it => it instanceof _StyleSet.ClassStyle && it.name === name && it.state === state);
    }
    return sets.find(it => it instanceof _StyleSet.BlockTypeStyle && it.type === name && it.layout == layout && it.state === state);
  }
  static fontStylesheet(val) {
    if (val.length > 0) {
      let fonts = val.map(it => `family=${encodeURIComponent(it)}:ital,wght@0,400;0,700;1,400;1,700`).join("&");
      return `@import url("https://fonts.googleapis.com/css2?${fonts}&display=swap");`;
    } else {
      return "";
    }
  }
  constructor(spec, registry) {
    (0, _defineProperty2.default)(this, "styleSets", void 0);
    (0, _defineProperty2.default)(this, "events", new _eventer.Eventer(false));
    this.spec = spec;
    this.registry = registry;
  }
  renderStylesheet(prefix) {
    if (this.styleSets) {
      return this.styleSets.map(set => set.toCss(prefix)).join("\n");
    }
    let fonts = new Set();
    let stylesheet = this.spec.map(style => StyleManager.styleToCss(style, prefix, fonts)).join("\n");
    let fontsheet = "";
    if (fonts.size > 0) {
      fontsheet = StyleManager.fontStylesheet(Array.from(fonts));
    }
    return fontsheet + stylesheet;
  }
  getStyles() {
    this.specToStyleSets();
    return [...this.styleSets];
  }
  getDefaultStyles() {
    if (!parsedDefaultStyles) {
      parsedDefaultStyles = (0, _StyleSet.cssToStyle)(_paletteDefaultStyles.paletteDefaultStyles);
    }
    return parsedDefaultStyles;
  }
  getSet(layer, create = true) {
    this.specToStyleSets();
    let set = StyleManager.findSet(this.styleSets, layer);
    if (!set && create) {
      let creator = layer.type === "root" ? _StyleSet.RootStyle : layer.type === "class" ? _StyleSet.ClassStyle : _StyleSet.BlockTypeStyle;
      set = new creator(new _StyleSet.StyleContainer(), layer.name, layer.state, layer.layout);
      set = Object.freeze(set);
      this.styleSets.unshift(set);
      this.sortStylesets();
      let index = this.styleSets.indexOf(set);
      this.events.emit("add", {
        set,
        index
      });
      this.registry.change({
        type: "style",
        op: "add"
      });
    }
    return set;
  }
  getLayers(layers) {
    return layers.map(it => this.getSet(it, false));
  }
  addClass(name) {
    let style = this.styleSets.find(it => it instanceof _StyleSet.ClassStyle && it.name === name);
    if (!style) {
      let set = Object.freeze(new _StyleSet.ClassStyle(new _StyleSet.StyleContainer(), name));
      this.styleSets.push(set);
      this.sortStylesets();
      let index = this.styleSets.indexOf(set);
      this.events.emit("add", {
        set,
        index
      });
      this.registry.change({
        type: "style",
        op: "add"
      });
    }
  }
  updateStyle(set, updates) {
    let existing = this.styleSets.indexOf(set);
    if (existing === -1) {
      throw new Error("Cant update a style that doesn't exist in the StyleManager");
    }
    let req = {};
    for (let it of updates) {
      set.css.setEntry(it);
      if (it.type === "select") {
        if (it.property === "display") {
          req.display = it.value;
        } else if (it.property === "position") {
          req.position = it.value;
        } else if (it.property === "font-family") {
          let family = getFontName(it.value);
          if (family) {
            let fontSet = this.styleSets.find(it => it.setType === "fonts");
            fontSet.fonts.add(family);
            this.events.emit("update", {
              set: fontSet
            });
          }
        }
      }
    }
    this.events.emit("update", {
      set,
      ...req
    });
    this.registry.change({
      type: "style",
      op: "update"
    });
  }
  removeStyle(set, property) {
    set.css.remove(property);
    let req = {};
    if (property === "display" || property === "position") {
      req[property] = null;
    }
    this.events.emit("update", {
      set,
      ...req
    });
    this.registry.change({
      type: "style",
      op: "remove"
    });
  }
  findColors() {
    this.specToStyleSets();
    let colors = new Set();
    function addColorValue(entry) {
      if (entry) {
        if (entry.type === "color") {
          if (entry.value && !entry.value.startsWith("var(")) {
            colors.add(entry.value);
          }
        } else if (entry.type === "composite") {
          var _entry$values$;
          if (entry.property.startsWith("border") && entry.values.length === 3 && (_entry$values$ = entry.values[2]) !== null && _entry$values$ !== void 0 && _entry$values$.value) {
            colors.add(entry.values[2].value);
          }
        }
      }
    }
    for (let set of this.styleSets) {
      addColorValue(set.get("color"));
      addColorValue(set.get("background-color"));
      addColorValue(set.get("border"));
      addColorValue(set.get("border-top"));
      addColorValue(set.get("border-right"));
      addColorValue(set.get("border-bottom"));
      addColorValue(set.get("border-left"));
    }
    return Array.from(colors);
  }
  sortStylesets() {
    this.styleSets.sort((a, b) => {
      if (a instanceof _StyleSet.FontStyle) {
        return -1;
      }
      if (b instanceof _StyleSet.FontStyle) {
        return 1;
      }
      if (a instanceof _StyleSet.RootStyle) {
        return -1;
      }
      if (b instanceof _StyleSet.RootStyle) {
        return 1;
      }
      if (a instanceof _StyleSet.ClassStyle) {
        if (b instanceof _StyleSet.ClassStyle) {
          if (a.state && !b.state) {
            return 1;
          }
          if (b.state && !a.state) {
            return -1;
          }
          return a.index - b.index;
        }
        return 1;
      }
      if (b instanceof _StyleSet.ClassStyle) {
        return -1;
      }
      if (a instanceof _StyleSet.BlockTypeStyle && b instanceof _StyleSet.BlockTypeStyle) {
        if (a.state && !b.state) {
          return 1;
        }
        if (b.state && !a.state) {
          return -1;
        }
        if (a.type === b.type) {
          if (a.layout) {
            if (b.layout) {
              return a.layout.localeCompare(b.layout);
            } else {
              return 1;
            }
          } else {
            if (b.layout) {
              return -1;
            }
            return 0;
          }
        }
        return a.type.localeCompare(b.type);
      } else if (a instanceof _StyleSet.BlockTypeStyle) {
        return 1;
      }
      return -1;
    });
  }
  specToStyleSets() {
    if (!this.styleSets) {
      this.styleSets = [];
      let defaults = (0, _StyleSet.cssToStyle)(_paletteDefaultStyles.paletteDefaultStyles);
      let fonts = new Set();
      for (let it of this.spec) {
        let container = _StyleSet.StyleContainer.fromJson(it.css);
        let fam = container.get("font-family");
        if (fam && fam.type === "select") {
          let family = getFontName(fam.value);
          if (family) {
            fonts.add(family);
          }
        }
        let def = StyleManager.findSet(defaults, {
          type: it.type ? "block" : it.name ? "class" : "root",
          name: it.name || it.type,
          layout: it.layout,
          state: it.state
        });
        if (def) {
          this.styleSets.push(Object.freeze(def.merge({
            css: container
          })));
          defaults.splice(defaults.indexOf(def), 1);
        } else {
          if (it.name) {
            this.styleSets.push(Object.freeze(new _StyleSet.ClassStyle(container, it.name, it.state)));
          } else if (it.type) {
            this.styleSets.push(Object.freeze(new _StyleSet.BlockTypeStyle(container, it.type, it.state, it.layout)));
          } else {
            this.styleSets.unshift(Object.freeze(new _StyleSet.RootStyle(container)));
          }
        }
      }
      this.styleSets.unshift(Object.freeze(new _StyleSet.FontStyle(Array.from(fonts))));
      this.styleSets = this.styleSets.concat(defaults);
      this.sortStylesets();
    }
  }
  toJSON() {
    this.specToStyleSets();
    return this.styleSets.map(it => it.toJSON()).filter(it => !!it);
  }
}
exports.StyleManager = StyleManager;
function getFontName(value) {
  let family = value.split(",")[0].replaceAll("'", "");
  if (!systemFonts.includes(family.toLowerCase())) {
    return family;
  }
  return null;
}
//# sourceMappingURL=StyleManager.js.map